import React from 'react';
import './FontProvider.scss';
import PropTypes from 'prop-types';

// Import all stylesheets up front to assist with roster printing,
//   as the styles need to be in the head before the print occurs
// Font files don't load until used
import './kiddie/kiddie.scss';
import './middle/middle.scss';
import './teacher/teacher.scss';

export const KIDDIE = 'kiddie';
export const MIDDLE = 'middle';
export const TEACHER = 'teacher';

export class FontProvider extends React.Component {
  static propTypes = {
    fontKey: PropTypes.string.isRequired,
  };

  render() {
    const classes = ['FontProvider'];
    if (this.props.fontKey) {
      classes.push(`FontProvider--${this.props.fontKey}`);
    }

    return <div className={classes.join(' ')}>{this.props.children}</div>;
  }
}
